import React from "react";

export const Logo = ({ className = "", color = "#0A192F" }) => (
  <div className={`flex items-center ${className}`} data-testid="silea-logo">
    <span
      className="font-serif-display text-xl tracking-[0.25em]"
      style={{ color, fontWeight: 500 }}
    >
      SILÉA
    </span>
  </div>
);
